// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2OOPC","label":"Section_label__2cpOs","contentWrap":"Section_contentWrap__3SVIF","footer":"Section_footer__1obFk","footerInner":"Section_footerInner__30IK1"};